import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Button from '../../../../atoms/Button';
import Icon, { SIZES } from '../../../../atoms/FontIcon';
import styles from './sortOrder.module.scss';
var SortOrderOption = function SortOrderOption(props) {
  var className = props.className,
    label = props.label,
    onClick = props.onClick,
    iconClassName = props.iconClassName;
  return /*#__PURE__*/React.createElement(Button, {
    view: Button.VIEW.TERTIARY,
    onClick: onClick,
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: SIZES.S,
    className: cx(iconClassName, 'mr-1', styles.iconClass)
  }), label));
};
SortOrderOption.defaultProps = {
  onClick: _noop,
  className: EMPTY_STRING,
  label: EMPTY_STRING,
  iconClassName: EMPTY_STRING
};
SortOrderOption.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.string,
  iconClassName: EMPTY_STRING
};
export default SortOrderOption;